import { TaskItemState } from '../../store/interfaces';
import { Task } from '../interfaces';

const updateExistingTaskState = (tasks: Task[], itemStatusArray: TaskItemState[] | undefined): Task[] => {
  let itemStatusMap: Record<string, TaskItemState> = {};
  let tasksWithItemStatus = tasks;

  if (itemStatusArray && itemStatusArray.length) {
    itemStatusMap = itemStatusArray.reduce((acc: Record<string, TaskItemState>, cur: TaskItemState) => {
      acc[cur.itemId] = cur;
      return acc;
    }, {});

    tasksWithItemStatus = tasks.map((task) => ({
      ...task,
      items: task.items.map((item) => {
        if (itemStatusMap[item.id]) {
          const stateString = itemStatusMap[item.id]?.state;
          const itemState = stateString && JSON.parse(stateString);
          return {
            ...item,
            responseReuseType: itemState?.responseReuseType,
            status: itemStatusMap[item.id].status,
            state: itemStatusMap[item.id].state,
          };
        }
        return item;
      }),
    }));
  }

  return tasksWithItemStatus;
};

export default updateExistingTaskState;
